import { Vector2, Texture, RepeatWrapping, NearestFilter } from "three";

function createTexture(canvas) {
  const texture = new Texture(canvas);
  texture.flipY = false;
  texture.needsUpdate = true;
  texture.wrapS = RepeatWrapping;
  texture.wrapT = RepeatWrapping;
  return texture;
}

function createBreakendTexture({ width, height }) {
  const pxRatio = window.devicePixelRatio || 1;
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const conf = { width, height, repeatVertical: false, repeatHorizontal: true };

  canvas.width = width * pxRatio;
  canvas.height = height * pxRatio;
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;

  ctx.scale(pxRatio, pxRatio);
  ctx.clearRect(0, 0, width, 1);

  ctx.beginPath();
  ctx.lineWidth = 1;

  ctx.strokeStyle = "#000000";

  ctx.moveTo(0, 1);
  ctx.lineTo(width, 1);

  ctx.moveTo(0, height);
  ctx.lineTo(width, height);

  ctx.moveTo(0, height / 2);
  ctx.lineTo(width, height / 2);

  ctx.stroke();

  ctx.lineWidth = 2.5;

  ctx.stroke();

  // ctx draw rectangle from point (0, 0) to (width, height)
  ctx.beginPath();
  ctx.lineWidth = 1;
  ctx.fillStyle = "rgba(0, 0, 0, 0.4)";
  ctx.moveTo(0, 0);
  ctx.lineTo(width, 0);
  ctx.lineTo(width, height);
  ctx.lineTo(0, height);

  ctx.fill();

  const texture = createTexture(canvas);
  texture.magFilter = NearestFilter;
  texture.minFilter = NearestFilter;
  const res = {
    uv: [
      new Vector2(0, 0), // texture to point -> top left
      new Vector2(1, 0), // texture to point -> top right
      new Vector2(0, 1), // texture to point -> bottom left
      new Vector2(1, 1), // texture to point -> bottom right
    ],
    texture: {
      textureConf: { ...conf, dir: 1 },
      texture,
    },
  };

  canvas.remove();

  return res;
}

export default createBreakendTexture;
